import type { ShortcutHandlerContext } from '../../../../../lib/types.js';
import { assertBridgeWorkspace } from '../../../../lib/assert-bridge-workspace.js';
import { handleShortcutCodeNav } from '../../../../lib/code-nav/handle-code-nav.js';

/** GET /api/bridges/files/code-nav */
export async function GET(ctx: ShortcutHandlerContext): Promise<void> {
  if (!assertBridgeWorkspace(ctx)) return;
  await handleShortcutCodeNav(ctx);
}
